import { render } from "./BillingInfoPage.vue?vue&type=template&id=5635ad6c&ts=true"
import script from "./BillingInfoPage.vue?vue&type=script&lang=ts"
export * from "./BillingInfoPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__